import { LoadingSpinner } from "widgets";

export const EmptyPage = () => {
  return (
    <div data-testid="empty-page" style={{ background: "var(--page-background)" }}>
      <LoadingSpinner inCenter />
    </div>
  );
};
